import { useState, useEffect } from 'react';
import { Header } from '../../../../common/Header/Header.jsx';
import { useParams, useHistory } from 'react-router-dom';
import { membershipService } from '../../../../../services/membershipService.js';
import { giftCardService } from '../../../../../services/giftCardService.js';
import { paymentsService } from '../../../../../services/paymentsService.js';
import { membershipCatalogService } from '../../../../../services/membershipCatalogService.js';
import { currencyRateService } from '../../../../../services/currencyRateService.js';
import { productService } from '../../../../../services/productService.js';
import { usersService } from '../../../../../services/usersService.js';
import authService from '../../../../../services/authService.js';
import { notify } from '../../../../../assets/helpers/toast.js';
import { OrderCard } from '../OrderComponents.jsx';
import { UpgradeInfoCard } from '../UpgradeInfoCard.jsx';
import { RCVInfoCard } from '../RCVInfoCard.jsx';
import { CreateGiftcardCard } from '../CreateGiftcardCard.jsx';
import { parsePhoneNumberWithError } from 'libphonenumber-js';
import {
  renameMembershipStatus,
  isPaymentMethodZelleOrPaypal,
  filterOptionById,
  clearObject,
  parseUrl,
  reverseParse,
  filterById,
  validateAmount0,
  validateProductsPayment,
  validatePMCashbackData
} from '../../../../../assets/helpers/funciones.js';
import { parseTitle } from './paymentSectionHelpers.js';
import {
  transactionTypes,
  transactionTypesArray,
  paymentMethods as metodosDePago,
  paymentType,
  RCV_Alliance_TYPE,
  LANDING,
} from '../../../../../assets/helpers/options.js';
import { PaymentCard } from '../PaymentSection/PaymentCard.jsx';
import { GiftCardPayments } from '../PaymentSection/GiftCardPayments.jsx';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import * as schemas from '../../../../../assets/schemas/schemas.js';
import { LoadSpinner } from '../../../../common/LoadSpinner/LoadSpinner.jsx';
import { MultipleRenewalsTable } from '../../MultipleRenewalTable.jsx';
import { multipleRenewalsPaymentTableHeader } from '../../../../../assets/helpers/tables.js';
import { medCert } from '../../../../../assets/helpers/variables.js';
import moment from 'moment';
import '../Order.scss';
import { MedCertInfoCard } from '../MedCertInfoCard.jsx';
import { RCVCard } from '../RCVCard.jsx';
import { cashReceiverService } from '../../../../../services/cashReceiverService.js';
import { useCasheaPayment } from '../../../../../hooks/payments/useCasheaPayment.jsx';
import { casheaLinkService } from '../../../../../services/casheaLinkService.js';

export const PaymentSection = () => {
  const { membershipId, transactionType, duePayment, giftcardId } = useParams();
  const [membership, setMembership] = useState('');
  const [euroRate, setEuroRate] = useState('');
  const [fileUploaded, setFileUploaded] = useState([]);
  const [cashBackImage, setCashBackImage] = useState([]);
  const [paymentDateRate, setPaymentDateRate] = useState('');
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [errorsDropzone, setErrorsDropzone] = useState({});
  const [cashReceiverOptions, setCashReceiverOptions] = useState([]);
  const [sellerOptions, setSellerOptions] = useState([]);
  const [showErrorAPI, setShowErrorAPI] = useState(false);
  const [useRcvAlliancePrice, setUseRcvAlliancePrice] = useState(
    RCV_Alliance_TYPE?.FULL_PRICE
  );
  const [membershipsDatatable, setMembershipsDatatable] = useState({
    offset: 0, //Elementos que ya pasaron la pagina
    data: [],
    count: 0, //Cantidad de elementos
    page: 1,
    dateFrom: '',
    dateTo: '',
    isLoading: false,
    searchParam: '',
  });

  const history = useHistory();

  // Redirect to dashboard if not propper payment type
  if (!transactionTypesArray.includes(transactionType)) {
    history.push('/dashboard/analytics');
  }

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    getValues,
    watch,
    control,
    setError,
  } = useForm({
    resolver: yupResolver(schemas.paymentSchema()),
  });

  // Inicial 0 con Cashea solo aplica a renovaciones, no a pago de cuotas
  const { isZeroInitialCashea, appendCasheaZeroInitial } = useCasheaPayment({
    watch,
    enabled: [
      transactionTypes.RENEWAL,
      transactionTypes.MULTIPLE_RENEWAL,
    ].includes(transactionType),
  });

  let loadPaymentForms = (params) => {
    let payments = [];
    // Con inicial 0 en Cashea no se construyen objetos de pago
    const paymentFormsQuantity = isZeroInitialCashea
      ? 0
      : parseInt(watch('paymentMethodsQuantity'));
    // lOOP through every payment method
    for (let i = 0; i < paymentFormsQuantity; i++) {
      let data = {};

      data.method = params[`method` + i.toString()];
      data.amount = parseFloat(params[`amount` + i.toString()]);
      data.amountBsS = params[`finalAmountBsS` + i.toString()];
      data.reference = params[`reference` + i.toString()];
      data.transactionBatch = params[`transactionBatch` + i.toString()];
      data.referenceCashea = watch('referenceCashea');
      data.owner = params[`owner` + i.toString()];
      data.igtfAmount = parseFloat(params[`IGTF` + i.toString()]);
      data.bank = params[`bank` + i.toString()];
      data.phone = params[`phone` + i.toString()];
      data.date = params[`date` + i.toString()];
      data.cashReceiver = params[`cashReceiver` + i.toString()];
      data.observation = params[`observation` + i.toString()];
      payments.push({
        ...data,
      });
    }

    params.payments = payments;
    return params;
  };

  const parseRCVHolder = () => {
    let rcvHolder = {
      isVehicleDriver: watch('isVehicleDriver') === 'false' ? false : true,
      firstName: watch('rcvHolderFirstName'),
      lastName: watch('rcvHolderLastName'),
      fullName: `${watch('rcvHolderFirstName')}  ${watch('rcvHolderLastName')}`,
      identification: watch('rcvHolderIdentification'),
      identificationType: watch('rcvHolderIdentificationType'),
      phonePrefix: watch('rcvHolderPhonePrefix'),
      phoneNumber: watch('rcvHolderPhoneNumber'),
      state: watch('rcvHolderState'),
      city: watch('rcvHolderCity'),
      address: watch('rcvHolderAddress'),
    };

    rcvHolder = clearObject(rcvHolder);

    return JSON.stringify(rcvHolder);
  };

  const appendFile = (data) => {
    const formData = new FormData();

    if ([transactionTypes.UPGRADE].includes(transactionType)) {
      formData.append('amount', watch('amount'));
      formData.append('amountBsS', watch('amountBsS'));
      formData.append('newCode', watch('newCode'));
      // Upgrade Appends
      if (watch('km')) {
        formData.append('km', watch('km'));
      }
      if (watch('hasExtendedTow')) {
        formData.append('useExtendedTow', watch('hasExtendedTow'));
      }
    }

    if ([transactionTypes.RENEWAL].includes(transactionType)) {
      formData.append('membership', membership?._id);
    } else if (
      [transactionTypes.DUE_PAYMENT].includes(transactionType) &&
      ![
        paymentType?.CASHEA,
        paymentType?.CASHEA_LINK,
        paymentType?.VENFLOW,
      ].includes(membership?.paymentType)
    ) {
      formData.append('membership', membership?._id);
    }

    if ([transactionTypes.MULTIPLE_RENEWAL].includes(transactionType)) {
      formData.append('renewalCart', true);
      formData.append('membership', membershipsDatatable.data[0].newMem._id);

      if (membershipsDatatable?.data?.length > 1) {
        for (let i = 1; i < membershipsDatatable?.data?.length; i++) {
          formData.append(
            `siblingMemberships[${i - 1}]`,
            membershipsDatatable.data[i].newMem._id
          );
        }
      }
    }

    if ([transactionTypes.RCV].includes(transactionType)) {
      formData.append('rcvHolder', parseRCVHolder());
      formData.append('rcv', data?.rcvType);
      formData.append(
        'rcvEmissionDate',
        moment(watch('rcvEmissionDate')).format('YYYY-MM-DD')
      );
      formData.append(
        'rcvBeginDate',
        moment(watch('rcvBeginDate')).format('YYYY-MM-DD')
      );
      formData.append(
        'rcvEndDate',
        moment(watch('rcvEndDate')).format('YYYY-MM-DD')
      );

      formData.append('useRcvCtgPrice', watch('useRcvCtgPrice') || false);

      if (useRcvAlliancePrice === RCV_Alliance_TYPE?.FULL_PRICE) {
        formData.append('useRcvAlliancePrice', false);
      }

      if (useRcvAlliancePrice === RCV_Alliance_TYPE?.SC_PRICE) {
        formData.append('useRcvAlliancePrice', true);
      }
    }

    // Payments Append and generic append
    if (
      [transactionTypes.UPGRADE, transactionTypes.RCV].includes(transactionType)
    ) {
      formData.append(
        'paymentStrategy',
        parseFloat(watch('paymentMethods')) > 1 ? 'Pago mixto' : 'Pago único'
      );
    }

    if (
      [transactionTypes.DUE_PAYMENT].includes(transactionType)
      //  &&
      // ![paymentType?.CASHEA].includes(membership?.paymentType)
    ) {
      formData.append('paymentType', reverseParse(duePayment));
    } else if (
      [paymentType?.CASHEA].includes(membership?.paymentType) &&
      [transactionTypes.RENEWAL].includes(transactionType)
    ) {
      formData.append('paymentType', watch('paymentType'));
    } else {
      if (![paymentType?.CASHEA].includes(membership?.paymentType)) {
        formData.append('paymentType', watch('paymentType'));
      }
    }

    if (validateProductsPayment(transactionType)) {
      formData.delete('paymentType');
      formData.append('paymentType', watch('paymentTypeFake'));
    }

    if (
      ![watch(`paymentType`), watch(`paymentTypeFake`)].some((pt) =>
        [paymentType?.COURTESY, paymentType?.PENDING].includes(pt)
      )
    ) {
      for (var i = 0; i < data?.payments.length; i++) {
        if (
          [
            metodosDePago?.CASH_USD,
            metodosDePago?.CASH_BS,
            metodosDePago?.CASH_EUR,
            metodosDePago?.PUNTO_DE_VENTA,
          ].includes(
            filterById(paymentMethods, data?.payments[i]?.method)?.name
          )
        ) {
          formData.append(
            `payments[${i}][cashReceiver]`,
            data?.payments[i]?.cashReceiver
          );
        }
        formData.append(`payments[${i}][method]`, data?.payments[i]?.method);
        if (data?.payments[i]?.observation) {
          formData.append(`payments[${i}][observation]`, data?.payments[i]?.observation);
        }
        formData.append(`payments[${i}][amount]`, data?.payments[i]?.amount);
        formData.append(
          `payments[${i}][amountBsS]`,
          data?.payments[i]?.amountBsS
        );
        formData.append(
          `payments[${i}][igtf]`,
          data?.payments[i]?.igtfAmount ? true : false
        );
        if (data?.payments[i]?.igtfAmount) {
          formData.append(
            `payments[${i}][igtfAmount]`,
            data?.payments[i]?.igtfAmount
          );
        }
        if (
          [metodosDePago?.PUNTO_DE_VENTA].includes(
            filterById(paymentMethods, data?.payments[i]?.method)?.name
          ) &&
          !data?.payments[i].reference
        ) {
          notify(
            'La referencia es obligatoria para el método Punto de Venta',
            'error'
          );
          return null;
        }
        if (
          ![metodosDePago?.VENPAY, metodosDePago?.ZELLE, metodosDePago?.PAYPAL].includes(
            filterById(paymentMethods, data?.payments[i]?.method)?.name
          )
        ) {
          formData.append(
            `payments[${i}][reference]`,
            data?.payments[i].reference
          );
        }
        if (
          data?.payments[i]?.transactionBatch !== undefined &&
          data?.payments[i]?.transactionBatch !== ''
        ) {
          formData.append(
            `payments[${i}][transactionBatch]`,
            data?.payments[i]?.transactionBatch
          );
        }

        if (showErrorAPI && watch(`skipApiValidationError${i}`)) {
          formData.append(
            `payments[${i}][skipApiValidationError]`,
            watch(`skipApiValidationError${i}`)
          );
        }
        // // Bank data
        // if (data?.payments[i]?.bank) {
        //   formData.append(`payments[${i}][phone]`, data?.payments[i]?.phone);
        //   formData.append(`payments[${i}][bank]`, data?.payments[i]?.bank);
        //   formData.append(`payments[${i}][date]`, data?.payments[i]?.date);
        // }

        // Send the flag if the payment has image or not
        formData.append(
          `payments[${i}][hasEvidence]`,
          fileUploaded[i] ? true : false
        );

        if (fileUploaded[i]?.name) {
          formData.append(`paymentEvidence`, fileUploaded[i]);
        }

        const method = filterOptionById(
          paymentMethods,
          data?.payments[i].method
        );

        if ([metodosDePago?.PAGO_MÓVIL_BANCAMIGA].includes(method?.name)) {
          formData.append(`payments[${i}][phone]`, data?.payments[i]?.phone);
          formData.append(
            `payments[${i}][date]`,
            moment(data?.payments[i].date).format('YYYY-MM-DD')
          );
        } else {
          formData.append(
            `payments[${i}][date]`,
            moment(data?.paymentDate).format('YYYY-MM-DD')
          );
        }

        if (
          [
            metodosDePago?.TRANSFERENCIA_BANCAMIGA,
            metodosDePago?.PAGO_MÓVIL_BANCAMIGA,
          ].includes(method?.name)
        ) {
          formData.append(`payments[${i}][bank]`, data?.payments[i]?.bank);
        }

        if ([paymentType?.CASHEA].includes(data?.paymentType)) {
          formData.append(
            `payments[${i}][referenceCashea]`,
            data?.payments[i]?.referenceCashea
          );
        }

        // Zelle, Venpay or Paypal payments
        if (
          isPaymentMethodZelleOrPaypal(
            data?.payments[i]?.method,
            paymentMethods
          )
        ) {
          formData.append(
            `payments[${i}][accHolder]`,
            data?.payments[i]?.owner
          );
        }
      }
    }
    if (data?.paymentType === paymentType?.CASHEA) {
      formData.append(`numCasheaDues`, 4);
    }

    if (isZeroInitialCashea) {
      appendCasheaZeroInitial(formData);
    }

    if (parseFloat(watch('cashbackMethodsQuantity')) > 0) {
      // Validate the total of the cashback
      // Validate that all images are up
      if (!validateCashBackTotal() || !validateCashBackImages()) {
        return null;
      }

      // Adjuntar valores de vuelto
      for (let j = 0; j < parseFloat(watch('cashbackMethodsQuantity')); j++) {
        formData.append(`paymentChanges[${j}][paid]`, data[`paid`]);
        formData.append(
          `paymentChanges[${j}][method]`,
          data[`returnedMethod${j}`]
        );
        formData.append(
          `paymentChanges[${j}][amount]`,
          data[`returnedAmount${j}`]
        );
        formData.append(
          `paymentChanges[${j}][amountBsS]`,
          data[`returnedAmountBsS${j}`]
        );
        if (data[`returnedReference${j}`]) {
          formData.append(
            `paymentChanges[${j}][ref]`,
            data[`returnedReference${j}`]
          );
        }
        if (watch(`observation${j}`)) {
          formData.append(
            `paymentChanges[${j}][observation]`,
            watch(`observation${j}`)
          );
        }
        if (!validatePMCashbackData(filterById(paymentMethods, data[`returnedMethod${j}`]), watch, j)) {
          return ""
        }


        if (watch(`cashBackphone${j}`)) {
          formData.append(
            `paymentChanges[${j}][phone]`,
            watch(`cashBackphone${j}`)
          );
          formData.append(
            `paymentChanges[${j}][bank]`,
            watch(`cashBackbank${j}`)
          );
          formData.append(
            `paymentChanges[${j}][identificationType]`,
            watch(`cashBackIdentificationType${j}`)
          );
          formData.append(
            `paymentChanges[${j}][identification]`,
            watch(`cashBackIdentification${j}`)
          );
        }

        if (cashBackImage[`image${j}`]) {
          formData.append(`paymentChanges[${j}][hasEvidence]`, true);
          formData.append(`paymentChangeEvidence`, cashBackImage[`image${j}`]);
        }
      }
    }

    if (
      [
        transactionTypes?.CREATE_GIFTCARD,
        transactionTypes?.EDIT_GIFTCARD,
      ].includes(transactionType)
    ) {
      formData.delete('paymentType'); // removes every entry named "fieldName"
      formData.append(`saleDate`, watch('paymentDate'));
      formData.append(`saleType`, watch('saleType'));
      formData.append(`seller`, watch('seller'));
      formData.append(`soldCardsCount`, watch('soldCardsCount'));

      // Customer
      formData.append(`customer[fullName]`, watch('fullName'));
      formData.append(
        `customer[identificationType]`,
        watch('identificationType')
      );
      formData.append(`customer[identification]`, watch('identification'));
      formData.append(`customer[email]`, watch('email'));
      const phone = parsePhoneNumberWithError(watch('phone'));
      formData.append(`customer[phonePrefix]`, phone.countryCallingCode);
      formData.append(`customer[phoneNumber]`, +phone.nationalNumber);

      for (let j = 0; j < parseFloat(watch('soldCardsCount')); j++) {
        if (data[`id${j}`]) {
          formData.append(`soldCards[${j}][id]`, data[`id${j}`]);
        }
        // if (giftcardId) {
        // }
        else {
          formData.append(`soldCards[${j}][plan]`, data[`plan${j}`]);
          formData.append(
            `soldCards[${j}][publicCode]`,
            data[`publicCode${j}`]
          );
          formData.append(
            `soldCards[${j}][saleChannel]`,
            data[`saleChannel${j}`]
          );
        }

        if (data[`discountCodeMongo${j}`]) {
          formData.append(
            `soldCards[${j}][discountCode]`,
            data[`discountCodeMongo${j}`]
          );
        }
        formData.append(`soldCards[${j}][rcvType]`, data[`rcvType${j}`]);
        formData.append(
          `soldCards[${j}][affiliationType]`,
          data[`affiliationType${j}`]
        );
        formData.append(
          `soldCards[${j}][unlimitedKm]`,
          data[`unlimitedKm${j}`] ? true : false
        );
        formData.append(
          `soldCards[${j}][vehicleClass]`,
          data[`vehicleClass${j}`]
        );
        formData.append(
          `soldCards[${j}][vehicleIsArmored]`,
          data[`vehicleIsArmored${j}`] && data[`vehicleIsArmored${j}`] !== 'No'
            ? true
            : false
        );
        formData.append(
          `soldCards[${j}][vehicleYear]`,
          data[`vehicleYear${j}`]
        );
        if (data[`vehicleUsage${j}`]) {
          formData.append(
            `soldCards[${j}][vehicleUsage]`,
            data[`vehicleUsage${j}`]
          );
        }
        // publicCodesOptions

        if (data[`planKm${j}`]) {
          formData.append(
            `soldCards[${j}][planKm]`,
            data[`planKm${j}`] ? data[`planKm${j}`] : ''
          );
        }

        // Plan info
        formData.append(
          `soldCards[${j}][priceInfo][initialValue]`,
          data[`selectedPlan${j}`][`originalPrice`]
            ? data[`selectedPlan${j}`][`originalPrice`]
            : 0
        );
        formData.append(
          `soldCards[${j}][priceInfo][yearSurcharge]`,
          data[`selectedPlan${j}`][`yearSurcharge`] || 0
        );
        formData.append(
          `soldCards[${j}][priceInfo][armorTypeSurcharge]`,
          data[`selectedPlan${j}`][`armorTypeSurcharge`] || 0
        );
        formData.append(
          `soldCards[${j}][priceInfo][classSurcharge]`,
          data[`selectedPlan${j}`][`classSurcharge`] || 0
        );
        formData.append(
          `soldCards[${j}][priceInfo][rcvSurcharge]`,
          data[`selectedPlan${j}`][`rcvSurcharge`] || 0
        );
        formData.append(
          `soldCards[${j}][priceInfo][extendedTowSurcharge]`,
          data[`selectedPlan${j}`][`extendedTowSurcharge`] || 0
        );
        formData.append(
          `soldCards[${j}][priceInfo][discountByCode]`,
          data[`selectedPlan${j}`][`discountByCode`] || 0
        );
        formData.append(
          `soldCards[${j}][priceInfo][discountToRcv]`,
          data[`selectedPlan${j}`][`discountToRcv`] || 0
        );
        formData.append(
          `soldCards[${j}][priceInfo][finalPriceBeforeDiscounts]`,
          data[`selectedPlan${j}`][`finalPriceBeforeDiscounts`] || 0
        );
        formData.append(
          `soldCards[${j}][priceInfo][finalPrice]`,
          data[`selectedPlan${j}`][`finalPrice`] || 0
        );
        formData.append(
          `soldCards[${j}][priceInfo][finalPriceInBsS]`,
          data[`selectedPlan${j}`][`finalPriceInBsS`] || 0
        );
        formData.append(
          `soldCards[${j}][priceInfo][medCertSurcharge]`,
          data[`selectedPlan${j}`][`medCertSurcharge`] || 0
        );
      }
    }

    return formData;
  };

  const PAYMENT_VALIDATION_ERROR_MESSAGE =
    'No pudimos validar el pago, por favor revisa los datos ingresados';

  const isPaymentValidationError = (response) =>
    [400].includes(response?.status) &&
    response?.data?.message === PAYMENT_VALIDATION_ERROR_MESSAGE;

  const handlePaymentValidationError = (response) => {
    setShowErrorAPI(true);
    setIsLoading(false);
    notify(response?.data?.message || response?.message, 'error');
  };

  const getCashReceivers = () => {
    cashReceiverService
      .getCashReceivers()
      .then((response) => {
        if (response.status === 200) {
          setCashReceiverOptions(response?.data?.cashReceivers);
        } else {
          notify(`${response.message}`, 'error');
        }
      })
      .catch((e) => {
        console.log('Error trayendo las cajas de efectivo', e);
      });
  };

  const upgradeMembership = (fileToPost) => {
    setIsLoading(true);
    membershipService
      .upgradeMembership(fileToPost, membership?._id)
      .then((response) => {
        if ([200, 201].includes(response.status)) {
          notify(`Upgrade de membresia exitoso`, 'success');
          history.push(`/afiliations/edit-order/${membership?._id}`);
          setIsLoading(false);
          sessionStorage.removeItem('paymentDate');
        }
        else if (isPaymentValidationError(response)) {
          handlePaymentValidationError(response);
        }
        else {
          notify(`${response.message}`, 'error');
          setIsLoading(false);
        }
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };

  const createGifcard = (fileToPost) => {
    setIsLoading(true);
    giftCardService
      .createParticularGiftcard(fileToPost)
      .then((response) => {
        if ([200, 201].includes(response.status)) {
          notify(`Giftcard creada con exito`, 'success');
          history.push(`/modules/giftcard-sales`);
          setIsLoading(false);
          sessionStorage.removeItem('paymentDate');
        }
        else if (isPaymentValidationError(response)) {
          handlePaymentValidationError(response);
        }
        else {
          notify(`${response.message}`, 'error');
          setIsLoading(false);
        }
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };

  const editGiftCard = (fileToPost) => {
    setIsLoading(true);
    giftCardService
      .editParticularGiftcard(fileToPost, giftcardId)
      .then((response) => {
        if ([200, 201].includes(response.status)) {
          notify(`Giftcard creada con exito`, 'success');
          history.push(`/modules/giftcard-sales`);
          setIsLoading(false);
          sessionStorage.removeItem('paymentDate');
        }
        else if (isPaymentValidationError(response)) {
          handlePaymentValidationError(response);
        }
        else {
          notify(`${response.message}`, 'error');
          setIsLoading(false);
        }
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };

  const addRCV = (fileToPost) => {
    setIsLoading(true);
    membershipService
      .addRCV(fileToPost, membership?._id)
      .then((response) => {
        if ([200, 201].includes(response.status)) {
          notify(`RCV añadido con exito`, 'success');
          history.push(`/afiliations/edit-order/${membership?._id}`);
          setIsLoading(false);
          sessionStorage.removeItem('paymentDate');
        }
        else if (isPaymentValidationError(response)) {
          handlePaymentValidationError(response);
        }
        else {
          notify(`${response.message}`, 'error');
          setIsLoading(false);
        }
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };

  const addMedicalCert = (fileToPost) => {
    setIsLoading(true);
    membershipService
      .addMedicalCert(fileToPost, membership?._id)
      .then((response) => {
        if ([200, 201].includes(response.status)) {
          notify(`Certificado Médico añadido con éxito`, 'success');
          history.push(`/afiliations/edit-order/${membership?._id}`);
          setIsLoading(false);
          sessionStorage.removeItem('paymentDate');
        }
        else if (isPaymentValidationError(response)) {
          handlePaymentValidationError(response);
        }
        else {
          notify(`${response.message}`, 'error');
          setIsLoading(false);
        }
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };

  const addRCVCard = (fileToPost) => {
    setIsLoading(true);
    membershipService
      .addRcvCard(fileToPost, membership?._id)
      .then((response) => {
        if ([200, 201].includes(response.status)) {
          notify(`Tarjeta de RCV añadida con éxito`, 'success');
          history.push(`/afiliations/edit-order/${membership?._id}`);
          setIsLoading(false);
          sessionStorage.removeItem('paymentDate');
        }
        else if (isPaymentValidationError(response)) {
          handlePaymentValidationError(response);
        }
        else {
          notify(`${response.message}`, 'error');
          setIsLoading(false);
        }
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };

  const createMembershipPayment = (fileToPost) => {
    setIsLoading(true);
    paymentsService
      .createMembershipPayment(fileToPost, membership?._id)
      .then((response) => {
        if ([200, 201].includes(response.status)) {
          notify(`Pago registrado con exito`, 'success');
          history.push(`/afiliations/edit-order/${membership?._id}`);
          setIsLoading(false);
          sessionStorage.removeItem('paymentDate');
        }
        else if (isPaymentValidationError(response)) {
          handlePaymentValidationError(response);
        }
        else {
          notify(`${response.message}`, 'error');
          setIsLoading(false);
        }
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };

  // Cashea Link en renovaciones: la inicial no vive en la membresía, hay que
  // volver a calcularla contra el mismo endpoint que usan afiliaciones nuevas.
  const queryCasheaLinkRenewalPlan = async (identification) => {
    const response = await casheaLinkService.getPayPlan(
      identification,
      watch('finalPrice')
    );
    if ([200, 201].includes(response.status)) {
      return { ok: true, initial: response?.data?.initial };
    }
    notify(response?.message || 'No se pudo consultar el plan de pago', 'error');
    return { ok: false };
  };

  const confirmCasheaLinkRenewalOrder = async (identification) => {
    const formData = appendFile({ payments: [] });
    formData.append('casheaCustomerIdentification', identification);
    setIsLoading(true);
    const response = await paymentsService.createMembershipPayment(formData);
    setIsLoading(false);
    if ([200, 201].includes(response.status)) {
      notify(`Pago registrado con exito`, 'success');
      sessionStorage.removeItem('paymentDate');
      // No redirige: CasheaLinkFlow muestra el link para copiar y el botón
      // "Consultar detalle" para que el usuario decida cuándo navegar.
      return { ok: true, data: response?.data };
    }
    if (isPaymentValidationError(response)) {
      handlePaymentValidationError(response);
      return { ok: false };
    }
    notify(`${response.message}`, 'error');
    return { ok: false };
  };

  const updateStatus = (membershipId) => {
    if (!isLoading) {
      setIsLoading(true);
      membershipService
        .updateMembershipStatus(membershipId)
        .then((response) => {
          if ([200, 201].includes(response?.status)) {
            setIsLoading(false);
            // notify(`Membresia aprobada`, 'success');
            history.push(`/afiliations/edit-order/${membershipId}`);
          } else {
            setIsLoading(false);
            notify(`${response.message}`, 'error');
          }
        })
        .catch((error) => {
          console.error('Error actualizando el status de la membresia', error);
          setIsLoading(false);
          notify(`Error actualizando el status de la membresia`, 'error');
        });
    }
  };

  const createPendingPayment = (fileToPost) => {
    setIsLoading(true);
    paymentsService
      .createPendingPayment(fileToPost, membership?._id)
      .then(async (response) => {
        if ([200, 201].includes(response.status)) {
          notify(`Pago registrado con exito`, 'success');
          await updateStatus(membership?._id)
          setIsLoading(false);
          sessionStorage.removeItem('paymentDate');
        }
        else if (isPaymentValidationError(response)) {
          handlePaymentValidationError(response);
        }
        else {
          notify(`${response.message}`, 'error');
          setIsLoading(false);
        }
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };

  const addMembershipPayment = (fileToPost) => {
    setIsLoading(true);
    paymentsService
      .addMembershipPayment(membership?._id, fileToPost)
      .then((response) => {
        if ([200, 201].includes(response.status)) {
          notify(`Pago registrado con exito`, 'success');
          history.push(`/afiliations/edit-order/${membership?._id}`);
          setIsLoading(false);
          sessionStorage.removeItem('paymentDate');
        }
        else if (isPaymentValidationError(response)) {
          handlePaymentValidationError(response);
        }
        else {
          notify(`${response.message}`, 'error');
          setIsLoading(false);
        }
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };

  const pay = handleSubmit(async (data) => {
    if (!isZeroInitialCashea && !validateAmount0(data, notify)) {
      return null;
    }

    let dataToPost = { ...data };

    dataToPost = loadPaymentForms(dataToPost);
    let fileToPost = appendFile(dataToPost);
    if (!isLoading && fileToPost) {
      // setIsLoading(true);
      if ([transactionTypes.CREATE_GIFTCARD].includes(transactionType)) {
        createGifcard(fileToPost);
      }
      if ([transactionTypes.EDIT_GIFTCARD].includes(transactionType)) {
        editGiftCard(fileToPost);
      }
      if ([transactionTypes.UPGRADE].includes(transactionType)) {
        upgradeMembership(fileToPost);
      }
      if ([transactionTypes.RCV].includes(transactionType)) {
        addRCV(fileToPost);
      }
      if ([transactionTypes.MEDICAL_CERT].includes(transactionType)) {
        addMedicalCert(fileToPost);
      }
      if ([transactionTypes.RCV_CARD].includes(transactionType)) {
        addRCVCard(fileToPost);
      }
      if ([transactionTypes.RENEWAL].includes(transactionType)) {
        createMembershipPayment(fileToPost);
      }

      if ([transactionTypes.MULTIPLE_RENEWAL].includes(transactionType)) {
        createMembershipPayment(fileToPost);
      }

      if ([transactionTypes.DUE_PAYMENT].includes(transactionType)) {
        if (
          [
            paymentType?.CASHEA,
            paymentType?.CASHEA_LINK,
            paymentType?.VENFLOW,
          ].includes(membership?.paymentType)
        ) {
          addMembershipPayment(fileToPost);
        } else {
          createPendingPayment(fileToPost);
        }
      }
    }
  });

  const validateCashBackTotal = () => {
    let cashbackMethodsQuantity = parseFloat(watch('cashbackMethodsQuantity'));
    let amountReturned = parseFloat(watch(`amountReturned`));
    let total = 0;
    for (let i = 0; i < cashbackMethodsQuantity; i++) {
      total = total + parseFloat(watch(`returnedAmount${i}`));
    }

    if (parseFloat(total?.toFixed(2)) !== amountReturned) {
      notify(
        'La suma de los montos debe ser igual al montoa a entregar',
        'error'
      );
      return false;
    } else {
      return true;
    }
  };

  const validateCashBackImages = () => {
    let cashbackMethodsQuantity = parseFloat(watch('cashbackMethodsQuantity'));
    let canPost = true;

    setErrorsDropzone((prevState) => {
      return {
        ...prevState,
        error1: false,
        error2: false,
        error3: false,
      };
    });

    for (let i = 0; i < cashbackMethodsQuantity; i++) {
      const requiredMetods = paymentMethods?.filter((method) =>
        [
          metodosDePago?.CASH_BS,
          metodosDePago?.CASH_EUR,
          metodosDePago?.CASH_USD,
          metodosDePago?.PUNTO_DE_VENTA,
        ]?.includes(method?.name)
      );
      const method = filterOptionById(
        requiredMetods,
        watch(`returnedMethod${i}`)
      );

      if (method && !watch(`returnedReference${i}`)) {
        setError(`returnedReference${i}`, {
          type: 'custom',
          message: 'Obligatorio',
        });
        canPost = false;
      }

      if (!cashBackImage[`image${i}`] && method) {
        notify(
          `Adjunte todos los comprobantes de pago de ${method?.name}`,
          'error'
        );
        canPost = false;
        setErrorsDropzone((prevState) => {
          return {
            ...prevState,
            [`error${i}`]: true,
          };
        });
      }
    }
    return canPost;
  };

  const getPaymentMethods = () => {
    productService
      .getPaymentMethods('sales')
      .then((response) => {
        if (response.status === 200) {
          const noCashea = response?.data?.filter(
            (d) => ![metodosDePago.CASHEA].includes(d?.name)
          );
          setPaymentMethods(noCashea);
        } else {
          notify(`${response.message}`, 'error');
        }
      })
      .catch(() => { });
  };

  const getEuroRate = () => {
    let params = {
      currency: 'EUR',
      date: watch('paymentDate')
        ? moment(watch('paymentDate')).format('YYYY-MM-DD')
        : '',
      limit: 1,
    };

    currencyRateService
      .getCurrencyRates(params)
      .then((response) => {
        if (response.status === 200) {
          setValue('euroRate', response?.data?.result[0]?.rate);
          setEuroRate(response?.data?.result[0]?.rate);
        } else {
          notify(`${response.message}` || 'error', 'error');
        }
      })
      .catch((error) => { });
    return true;
  };

  const handleUseRcvAlliancePrice = (value) => {
    if (value === RCV_Alliance_TYPE?.FULL_PRICE) {
      setValue('useRcvAlliancePrice', false);
      setValue('useRcvCtgPrice', false);
      setUseRcvAlliancePrice(value);
      getMembershipCatalog(membership, value);
    }
    if (value === RCV_Alliance_TYPE?.SC_PRICE) {
      setValue('useRcvAlliancePrice', true);
      setValue('useRcvCtgPrice', false);
      setUseRcvAlliancePrice(value);
      getMembershipCatalog(membership, value);
    }

    if (value === RCV_Alliance_TYPE?.CTG_PRICE) {
      setValue('useRcvAlliancePrice', false);
      setValue('useRcvCtgPrice', true);
      setUseRcvAlliancePrice(value);
      getMembershipCatalog(membership, value);
    }
  };

  const handleMembershipValueChangeInEuro = () => {
    setValue(
      'amount',
      (
        (watch('euroAmount') * watch('euroRate')?.toFixed(2)) /
        watch('dollarRate')
      )?.toFixed(2)
    );
    setValue('amountBsS', (watch('euroAmount') * euroRate).toFixed(2));
  };

  const getSalesMembershipById = (membershipId) => {
    if (!membershipId) return;
    membershipService
      .getSalesMembershipById(membershipId)
      .then((response) => {
        if ([200, 201].includes(response?.status)) {
          setMembership(response?.data);
          preloadRenewal(response?.data);
        } else {
          notify(`${response.message}`, 'error');
        }
      })
      .catch((error) => { });
  };

  const getMembershipCatalog = (membership, alliance) => {
    let params = {
      year: membership?.vehicle?.year,
      rcv: watch('rcvType'),
      class: membership?.vehicle?.classId,
      plan: membership?.membershipCode,
      landing: LANDING?.PRIVATE,
      rcvEmissionDate: moment(watch('rcvEmissionDate')).format('YYYY-MM-DD'),
      truckWeight: membership?.vehicle?.truckWeight,
      vehicleUsage: membership?.vehicle?.vehicleUsage,
    };

    if (alliance === RCV_Alliance_TYPE?.FULL_PRICE) {
      params.useRcvAlliancePrice = false;
    }

    if (alliance === RCV_Alliance_TYPE?.SC_PRICE) {
      params.useRcvAlliancePrice = true;
    }

    if (alliance === RCV_Alliance_TYPE?.CTG_PRICE) {
      params.useRcvCtgPrice = true;
      params.useRcvAlliancePrice = false;
    }

    if ([transactionTypes.MEDICAL_CERT].includes(transactionType)) {
      setValue('amount', medCert);
      setValue('amountBsS', (medCert * paymentDateRate).toFixed(2));
      return true;
    }
    if ([transactionTypes.RCV_CARD].includes(transactionType)) {
      setValue('amount', 1);
      setValue('amountBsS', (1 * paymentDateRate).toFixed(2));
      return true;
    }

    membershipCatalogService
      .getAvailableMemberships(params)
      .then((response) => {
        if ([200, 201].includes(response?.status)) {
          let plan = response?.data[0];

          if (plan) {
            if (
              plan?.rcvSurchargeEur <= 0 ||
              params.useRcvAlliancePrice === true ||
              params.useRcvCtgPrice === true
            ) {
              setValue('amount', plan?.rcvSurcharge);
              setTimeout(() => {
                setValue(
                  'amountBsS',
                  (plan?.rcvSurcharge * paymentDateRate).toFixed(2)
                );
              }, 1500);
            } else {
              let amount = (plan?.rcvSurchargeEur * euroRate) / paymentDateRate;
              setValue('euroAmount', plan?.rcvSurchargeEur);
              setTimeout(() => {
                setValue(
                  'amountBsS',
                  (watch('euroAmount') * euroRate).toFixed(2)
                );
                setValue('amount', amount.toFixed(2));
              }, 1500);
            }
          } else {
            notify(
              'No hay planes disponibles para el vehiculo seleccionado',
              'error'
            );
          }
        } else {
          notify(`${response.message}`, 'error');
        }
      })
      .catch((error) => { });
  };

  const getPaymentDateRate = (paymentDate) => {
    let params = {
      currency: 'USD',
      date:
        paymentDate || watch('paymentDate')
          ? moment(paymentDate || watch('paymentDate')).format('YYYY-MM-DD')
          : '',
      limit: 1,
    };
    currencyRateService
      .getCurrencyRates(params)
      .then((response) => {
        if (response.status === 200) {
          let rate = response?.data?.result[0]?.rate;
          setPaymentDateRate(rate);
          setValue(
            'finalPriceInBsS',
            (parseFloat(watch('finalPrice')) * rate)?.toFixed(2)
          );

          // if ([transactionTypes.UPGRADE, transactionTypes.RCV].includes(transactionType)) {
          //   setValue("amountBsS", (parseFloat(watch('amount')) * rate)?.toFixed(2))
          // }
          if ([transactionTypes.UPGRADE, transactionTypes.RCV_CARD, transactionTypes.MEDICAL_CERT].includes(transactionType)) {
            setValue(
              'amountBsS',
              (parseFloat(watch('amount')) * rate)?.toFixed(2)
            );
          }
          if (watch('paymentType') === paymentType?.DE_CONTADO) {
            setValue('billAmount', watch('finalPrice'));
            setValue('method0', '');
            setValue('amount0', watch('finalPrice'));
            setValue('amountBsS0', watch('finalPriceInBsS'));
          }
          getRenewalCart(rate);
        } else {
          notify(`${response.message}` || 'error', 'error');
        }
      })
      .catch(() => { });
  };

  const preloadDate = () => {
    const paymentDate = sessionStorage.getItem('paymentDate');
    if (paymentDate) {
      setValue('paymentDate', moment(paymentDate).format('YYYY-MM-DD'));
    } else {
      setValue('paymentDate', moment(new Date()).format('YYYY-MM-DD'));
    }
    getPaymentDateRate(paymentDate);
    getEuroRate();
  };

  const preloadRenewal = (membership) => {
    if (
      [transactionTypes.RENEWAL, transactionTypes.DUE_PAYMENT].includes(
        transactionType
      ) &&
      !Object.values(paymentType).some(
        (value) => parseUrl(value) === parseUrl(duePayment)
      )
    ) {
      history.push('/dashboard/analytics');
    }

    if ([transactionTypes.RENEWAL].includes(transactionType)) {
      setValue('paymentMethodsQuantity', 1);
      setValue('finalPrice', membership?.priceInfo?.finalPrice?.toFixed(2));
      setValue('paymentType', reverseParse(duePayment));
      setValue(
        'finalPriceInBsS',
        (watch('finalPrice') * paymentDateRate).toFixed(2)
      );

      // Renovaciones financiadas inicializan en 0
      if (![parseUrl(paymentType.FINANCIADO)].includes(duePayment)) {
        setValue('billAmount', membership?.priceInfo?.finalPrice?.toFixed(2));
        setValue('amount0', membership?.priceInfo?.finalPrice?.toFixed(2));
        setValue('amountBsS0', (watch('amount0') * paymentDateRate).toFixed(2));
      }
    }

    if ([transactionTypes.DUE_PAYMENT].includes(transactionType)) {
      if ([paymentType?.PENDING].includes(reverseParse(duePayment))) {
        setValue('paymentMethodsQuantity', 1);
        setValue('finalPrice', membership?.priceInfo?.finalPrice?.toFixed(2));
        setValue(
          'finalPriceInBsS',
          (watch('finalPrice') * paymentDateRate).toFixed(2)
        );
        setValue('paymentType', paymentType.DE_CONTADO);
        setValue('billAmount', watch('finalPrice'));
        setValue('amount0', watch('finalPrice'));
        setValue(
          'amountBsS0',
          (watch('finalPrice') * paymentDateRate).toFixed(2)
        );
      } else if (
        [
          parseUrl(paymentType?.CASHEA),
          parseUrl(paymentType?.CASHEA_LINK),
          parseUrl(paymentType?.VENFLOW),
        ].includes(parseUrl(reverseParse(duePayment)))
      ) {
        setValue('paymentMethodsQuantity', 1);
        setValue('finalPrice', membership?.pendingToPay);
        setValue(
          'finalPriceInBsS',
          (watch('finalPrice') * paymentDateRate).toFixed(2)
        );
        setValue('paymentStrategy', paymentType?.CASHEA);
        setValue('paymentType', paymentType.DE_CONTADO);
        setValue('billAmount', watch('finalPrice'));
        setValue('amount0', watch('finalPrice'));
        setValue(
          'amountBsS0',
          (watch('finalPrice') * paymentDateRate).toFixed(2)
        );
      } else {
        const nextPayment = membership.paymentDues?.find((p) => !p.paymentDate);
        setValue('paymentMethodsQuantity', 1);
        setValue(
          'finalPrice',
          nextPayment.amount?.toFixed(2)
            ? nextPayment.amount?.toFixed(2)
            : membership?.pendingToPay
        );
        setValue(
          'finalPriceInBsS',
          (watch('finalPrice') * paymentDateRate).toFixed(2)
        );
        setValue('paymentType', paymentType.DE_CONTADO);
        setValue('billAmount', watch('finalPrice'));
        setValue('amount0', watch('finalPrice'));
        setValue(
          'amountBsS0',
          (watch('finalPrice') * paymentDateRate).toFixed(2)
        );
      }
    }
  };

  const getRenewalCart = (paymentDateRate) => {
    if (transactionTypes.MULTIPLE_RENEWAL !== transactionType) return;

    setMembershipsDatatable((prevState) => {
      return {
        ...prevState,
        isLoading: true,
      };
    });

    membershipService
      .getRenewalCart()
      .then((response) => {
        if (response.status === 200) {
          setMembershipsDatatable((prevState) => {
            return {
              ...prevState,
              data: response?.data?.items,
              isLoading: false,
            };
          });

          let amount = 0;
          let amountBs = 0;

          for (let i = 0; i < response?.data?.items.length; i++) {
            amount =
              amount + response?.data?.items[i]?.newMem?.priceInfo?.finalPrice;
            amountBs =
              amountBs +
              response?.data?.items[i]?.newMem?.priceInfo?.finalPriceInBsS;
          }

          setValue('paymentMethodsQuantity', 1);
          setValue('finalPrice', amount);
          setValue(
            'paymentType',
            [parseUrl(paymentType?.CASHEA)].includes(
              parseUrl(reverseParse(duePayment))
            )
              ? paymentType?.CASHEA
              : reverseParse(duePayment)
          );
          setValue('finalPriceInBsS', amount * paymentDateRate);

          // Renovaciones financiadas inicializan en 0
          if (![parseUrl(paymentType.FINANCIADO)].includes(duePayment)) {
            setValue('billAmount', amount);
            setValue('amount0', amount);
            setValue('amountBsS0', amountBs.toFixed(2));
          }
        } else {
          notify(`${response.message}` || 'error', 'error');
          setMembershipsDatatable((prevState) => {
            return {
              ...prevState,
              isLoading: false,
            };
          });
        }
      })
      .catch(() => { });
  };

  const getUsers = async () => {
    let user = localStorage.getItem('user');

    if (user) {
      let params = {
        limit: 1000000,
        offset: 0,
        module: 'Ventas',
        status: 'Activo',
      };
      usersService
        .getUsers(params)
        .then((response) => {
          if (response.status === 200) {
            let data = [];
            for (let i = 0; i < response?.data?.users?.length; i++) {
              data?.push({
                _id: response?.data?.users[i]?._id,
                name:
                  response?.data?.users[i]?.firstName +
                  '  ' +
                  response?.data?.users[i]?.lastName,
              });
            }

            setSellerOptions(data);

            let [selectedUser] = data?.filter(
              (user) => user?._id === authService?.getUser()?._id
            );
            setValue('seller', selectedUser?._id);
          } else {
            notify(`${response.message}` || 'error', 'error');
          }
        })
        .catch(() => { });
    }
  };


  useEffect(() => {
    preloadDate();
    getPaymentMethods();
    getSalesMembershipById(membershipId);
  }, [setValue]);

  useEffect(() => {
    getUsers()
    getPaymentMethods();
    getCashReceivers();
  }, []);

  useEffect(() => {
    getSalesMembershipById(membershipId);
  }, [paymentDateRate, euroRate]);

  useEffect(() => {
    if (!['', 'N/A', 'RCV BÁSICO']?.includes(watch('rcvType'))) {
      getMembershipCatalog(membership, useRcvAlliancePrice);
    }
  }, [watch('rcvEmissionDate'), paymentDateRate, euroRate]);

  const options = {
    paymentMethods: paymentMethods,
  };
  const form = {
    register,
    handleSubmit,
    errors,
    setValue,
    getValues,
    watch,
    control,
    setError,
  };

  const upgradeCard = {
    form: form,
    dollarRate: paymentDateRate,
    options: { sellerOptions: sellerOptions },
    onChange: {
      getPaymentDateRate: getPaymentDateRate,
    },
  };

  const medCertCard = {
    form: form,
    dollarRate: paymentDateRate,
    options: { sellerOptions: sellerOptions },
    onChange: {
      getPaymentDateRate: getPaymentDateRate,
    },
  };

  const crvCard = {
    useRcvAlliancePrice,
    onChange: {
      handleUseRcvAlliancePrice: handleUseRcvAlliancePrice,
      handleMembershipValueChangeInEuro: handleMembershipValueChangeInEuro,
      getPaymentDateRate: getPaymentDateRate,
      getEuroRate: getEuroRate,
    },
    options: { sellerOptions: sellerOptions },
    form: form,
    euroRate: euroRate,
    dollarRate: paymentDateRate,
  };

  const paymentCard = {
    getPaymentDateRate: getPaymentDateRate,
    options: options,
    form: form,
    dollarRate: paymentDateRate,
    params: { transactionType, duePayment },
    isZeroInitialCashea,
    showErrorAPI,
    fileUploaded,
    setFileUploaded,
    cashBackImage,
    setCashBackImage,
    errorsDropzone,
    transactionType,
    actions: { pay: pay },
    cashReceiverOptions,
    casheaLink: {
      onQueryPlan: queryCasheaLinkRenewalPlan,
      onConfirmOrder: confirmCasheaLinkRenewalOrder,
      onCancel: () => history.push(`/afiliations/edit-order/${membership?._id}`),
    },
  };

  const multipleRenewalsTable = {
    header: multipleRenewalsPaymentTableHeader,
    data: membershipsDatatable?.data,
  };
  return (
    <>
      <LoadSpinner show={isLoading} />
      <Header />

      {!membership && (
        <div className="service-with-container container">
          <h1 className="title-component">Venta de Giftcards</h1>
          <div className="breadcrumb-container"></div>
          <div className="filter-button-container"></div>
          <div className="row">
            {transactionTypes.CREATE_GIFTCARD === transactionType && (
              <CreateGiftcardCard
                label={'INFORMACIÓN DE GIFT CARD'}
                membership={membership}
                card={crvCard}
                pay={pay}
              />)}
            <PaymentCard
              label={'PAGOS REALIZADOS'}
              membership={membership}
              card={paymentCard}
            />
            {giftcardId && (
              <GiftCardPayments
                label={'EDICION DE PAGOS'}
                membership={membership}
                card={paymentCard}
              />
            )}
          </div>
          <br />
        </div>
      )}

      {membership && (
        <div className="service-with-container container">
          <h1 className="title-component">
            {transactionTypes.MULTIPLE_RENEWAL !== transactionType && (
              <>
                {parseTitle(transactionType, membership?.membershipId) + ' '}
                {renameMembershipStatus(membership?.membershipStatus)}
              </>
            )}
            {transactionTypes.MULTIPLE_RENEWAL === transactionType && (
              <>Resumen de Membresias</>
            )}
          </h1>
          <div className="breadcrumb-container"></div>
          <div className="filter-button-container"></div>
          <br />
          <div className="row">
            <div className="col-12">
              {multipleRenewalsTable?.data?.length > 0 && (
                <MultipleRenewalsTable table={multipleRenewalsTable} />
              )}
            </div>
            <div className="col-12 col-lg-9">
              {[transactionTypes.UPGRADE].includes(transactionType) && (
                <UpgradeInfoCard
                  label={'INFORMACIÓN DE UPGRADE'}
                  membership={membership}
                  card={upgradeCard}
                />
              )}
              {[transactionTypes.RCV].includes(transactionType) && (
                <RCVInfoCard
                  label={'INFORMACIÓN DE RCV'}
                  membership={membership}
                  card={crvCard}
                />
              )}
              {[transactionTypes.MEDICAL_CERT].includes(transactionType) && (
                <MedCertInfoCard
                  label={'INFORMACIÓN DE CERTIFICADO MÉDICO'}
                  membership={membership}
                  card={medCertCard}
                />
              )}
              {[transactionTypes.RCV_CARD].includes(transactionType) && (
                <RCVCard
                  label={'INFORMACIÓN DE TARJETA RCV'}
                  membership={membership}
                  card={medCertCard}
                />
              )}
              <PaymentCard
                label={'PAGOS REALIZADOS'}
                membership={membership}
                card={paymentCard}
              />
            </div>
            {transactionTypes.MULTIPLE_RENEWAL !== transactionType && (
              <div className="col-12 col-lg-3">
                <OrderCard
                  membership={membership}
                  refresh={() => getSalesMembershipById(membershipId)}
                  hideCancelButton={true}
                />
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};
